import { QUERY_DEFAULTS } from '@/shared/lib/constants';

export const GLOSSARY_CONFIG = {
  API: {
    GLOSSARIES_LIMIT: 50,
    TERMS_LIMIT: 1000,
  },
  QUERY: {
    STALE_TIME: QUERY_DEFAULTS.STALE_TIME.LONG,
  },
} as const;
